module.exports = require("plugin-liverig/shared/asset/styled");